import {http} from '@/http/index.js';

async function updateProfile(data) {
  return http.post('/girl/profile', data).then((response) => response.data);
}

export {updateProfile};
